import React from "react";
import s from "./style.module.scss";
import EditProfileForm from "features/EditProfileForm";

const ProfileContent: React.FC = () => {
  return (
    <section className={s.content}>
      <h1>Профиль</h1>

      <p>
        Расскажите о себе подробнее. Мы поздравим вас с днём рождения и начислим
        дополнительные баллы
      </p>

      <EditProfileForm />
    </section>
  );
};

export default ProfileContent;
